import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

export interface SupportCard {
  id: string;
  title: string;
  description: string;
  route?: string;
  fragment?: string;
  comingSoon?: boolean;
  href?: string;
}

export interface QuickLink {
  id: string;
  title: string;
  route?: string;
  href?: string;
}

export interface ContactMethod {
  id: string;
  title: string;
  value: string;
  description: string;
}

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
})
export class SupportComponent {
  searchQuery = '';

  supportCards: SupportCard[] = [
    {
      id: 'faq',
      title: 'FAQ',
      description: 'Find answers to frequently asked questions and common issues',
      route: '/',
      fragment: 'faq',
    },
    {
      id: 'user-manual',
      title: 'User Manual',
      description: 'Comprehensive documentation and step-by-step guides',
      route: '/user-manual',
    },
    {
      id: 'contact-us',
      title: 'Contact Us',
      description: 'Contact our support team for personalized assistance',
      route: '/contact-us',
    },
  ];

  quickLinks: QuickLink[] = [
    { id: '1', title: 'Getting Started Guide', route: '/consumer/support/getting-started' },
    { id: '2', title: 'Account Settings', route: '/consumer/support/account' },
    { id: '3', title: 'Data Access & Permissions', route: '/consumer/support/data-access' },
    { id: '4', title: 'API Documentation', route: '/consumer/support/api' },
    { id: '5', title: 'Troubleshooting', route: '/consumer/support/troubleshooting' },
    { id: '6', title: 'Security & Privacy', route: '/consumer/support/security' },
  ];

  contactMethods: ContactMethod[] = [
    {
      id: 'email',
      title: 'Email Support',
      value: 'support@mahaagx.com',
      description: 'We typically respond within 24 hours',
    },
    {
      id: 'phone',
      title: 'Phone Support',
      value: '+1 (555) 123-4567',
      description: 'Mon-Fri, 9 AM - 5 PM EST',
    },
    {
      id: 'chat',
      title: 'Live Chat',
      value: 'Start Chat',
      description: 'Average response time: 2 minutes',
    },
  ];

  onSearch(): void {
    console.log('Searching for:', this.searchQuery);
    // Implement search functionality
  }
}

